import {
  fieldTraitProgressBarOptions,
  textTraitDateOptions,
  fieldTraitTextContentOptions,
} from '../../dataGroup/traitsApi';
import { getCollectionFields } from '../../pluginComponentApi';
export const HeatMapChartBlock = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-calendar3"></i><div>${label}</div>`,
    category: category,
    content: `<div data-gjs-type="heat_map_chart">
                <img src="https://public-webconnect.s3.amazonaws.com/chart/heat-map.png" alt="Heatmap"  />
            </div>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-calendar3"></i>',
          projectId: projectId,
          traits: [
            {
              type: 'number',
              label: 'Height',
              name: 'chartHeight',
              changeProp: 1,
              value: 300,
              min: 100,
              step: 10,
              max: 1000,
            },
            {
              type: 'text',
              label: 'Title',
              name: 'title',
              changeProp: 1,
            },
          ],
          script: function () {
            const title = '{[ title ]}';
            const chartHeight = '{[ chartHeight ]}';

            let collectionId = '{[ collectionName ]}';
            const finderId = '{[ finderUuid ]}';

            const chartData = {
              title,
              chartHeight,
            };
            if (typeof renderHeatMapChart !== 'undefined') {
              renderHeatMapChart(this, chartData, collectionId, finderId);
            }
          },
        },
        async init() {
          const collectionName = this.get('collectionName');
          let options = collections.map((item) => {
            return { value: item.collectionName, name: item.collectionTitle };
          });

          this.addTrait([
            {
              type: 'select',
              label: 'Collection',
              name: 'collectionName',
              changeProp: 1,
              options: options,
            },
            {
              type: 'select',
              label: 'Filter',
              name: 'finderUuid',
              changeProp: 1,
            },
          ]);
          if (collectionName) {
            const selectedCollection = collections.data.find(
              (collection) => collection.collectionName === collectionName,
            );
            const finderOptions = selectedCollection
              ? selectedCollection.finders.map((finder) => {
                  return { value: finder.uuid, name: finder.name };
                })
              : [];
            this.getTrait('finderUuid').set({ options: finderOptions });
          }
          this.on('change:collectionName', this.handleCollectionChange);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collection = await getCollectionFields(collectionName, collections);
          this.setAttributes({
            selectedCollectionData: collection,
          });
          if (collection) {
            const finderOptions = [];
            collection.finders.forEach((finder) => {
              finderOptions.push({ value: finder.uuid, name: finder.name });
            });
            this.getTrait('finderUuid').set({ options: finderOptions });
            this.removeTrait('data-series-name');
            this.removeTrait('data-series-data-x');
            this.removeTrait('data-series-data-y');
            const numberFieldTraitsOptions = fieldTraitProgressBarOptions(collection);
            const fieldTraitTextContentOptions = await textTraitDateOptions(collection);
            this.addTrait({
              name: 'data-series-name',
              label: 'Series Data Name',
              options: fieldTraitTextContentOptions,
              title: `series-name`,
              type: 'data-series-trait',
            });
            this.addTrait({
              name: 'data-series-data-x',
              label: 'Series Data X',
              options: fieldTraitTextContentOptions,
              title: `series-data-x`,
              type: 'data-series-trait',
            });
            this.addTrait({
              name: 'data-series-data-y',
              label: 'Series Data Y',
              options: numberFieldTraitsOptions,
              title: `series-data-y`,
              type: 'data-series-trait',
            });
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:title', this.updateScript);
        this.listenTo(model, 'change:chartHeight', this.updateScript);
      },
    }),
  });
};
